// v3.16.x: Force-login khi token chết, dùng chung cho `avatar sync` + `avatar init`.
//
// Tách file riêng (thay vì nhét vào user-config-store.ts) để getValidIdToken có
// thể mock được qua module boundary trong test — gọi cùng-module (self-call)
// trong ESM KHÔNG đi qua object export đã mock, nên phải tách để vi.mock hoạt động.
import { runLogin } from "../commands/login.js";
import { getValidIdToken, NoValidTokenError } from "./user-config-store.js";

// Gọi getValidIdToken() (đã tự refresh nếu cần, verify claims mọi nhánh — xem
// user-config-store.ts). Nếu ném NoValidTokenError (chưa login / refresh_token
// revoked / refresh không trả id_token mới) → chạy interactive login flow rồi
// retry đúng 1 lần. Lỗi KHÁC (network, InvalidIdToken...) → propagate nguyên
// trạng, KHÔNG nuốt, KHÔNG trigger login (login chỉ dành cho "hết credential hợp lệ").
export async function ensureValidTokenOrLogin(): Promise<string> {
  try {
    return await getValidIdToken();
  } catch (err) {
    if (!(err instanceof NoValidTokenError)) throw err;

    const { log } = await import("./terminal-logger.js");
    log.info("Token hết hạn hoặc chưa đăng nhập — đăng nhập lại...");

    await runLogin({});

    // Retry sau login. Nếu vẫn fail (vd login thành công nhưng ghi config lỗi) →
    // để lỗi propagate nguyên trạng, KHÔNG nuốt thành vòng lặp vô hạn.
    return await getValidIdToken();
  }
}
